import HTTP from '@/utils/http-common';

const config = { headers: { 'Content-Type': 'multipart/form-data' } };

const getOrderCustomer = (orderId) => HTTP.get(`/orders/${orderId}/customers`);
const getOrderFollowUps = (orderId) => HTTP.get(`/orders/followups/${orderId}`);
const createOrder = (order) => HTTP.post('/orders', order);
const updateOrder = async (order) => (await HTTP.put(`/orders/${order.orderId}`, order)).data.model;
const patchOrder = async (orderId, data) => (await HTTP.patch(`/orders/${orderId}`, data)).data.model;
const createOrderFollowUp = (followUp) => HTTP.post(`/orders/${followUp.orderId}/followup`, followUp);
const getOrderFollowUp = (followUpId) => HTTP.get(`/orders/followup/${followUpId}`);
const createOrderFollowUpNote = (note) => HTTP.post('/orders/followups/note', note);
const updateOrderFollowUp = (followUp, orderId) => HTTP.put(`/orders/${orderId}/followup`, followUp);
const searchFollowUps = (query) => HTTP.post('/orders/followups/search', query);
const getFollowUpTypeCount = async (data) => (await HTTP.post('/orders/followups/type/count', data)).data;
const getFollowUpTypePastCount = async (data) => (await HTTP.post('/orders/followups/type/pastcount', data)).data;
const getLastViewedOrders = (count) => HTTP.get(`/orders/by-date/${count}`);
const sendPurchaseInvoice = (data) => HTTP.post('/orders/purchaseinvoice', data);
const getOneOrderDetail = (orderId, detailId) => HTTP.get(`/orders/${orderId}/details/${detailId}?populateOrder=1`);
const uploadOrderDocuments = (orderId, formData) => HTTP.post(`/orders/${orderId}/documents`, formData, config);
const deleteOrderDocuments = (documentId, orderId) => HTTP.delete(`/orders/${orderId}/documents/${documentId}`);
const updateOrderDocument = (orderId, document) => HTTP.put(`/orders/${orderId}/documents/${document._id}`, document);
const saveOrderDocument = (orderId, document) => HTTP.patch(`/orders/${orderId}/documents`, document);
const getOrderFollowUpTypes = () => HTTP.get('/orders/followup/type');
const getOrderPayments = async (orderId) => (await HTTP.get(`/orders/${orderId}/order-payments`)).data;
const createDocumentPayment = async (orderId, payment) =>
  (await HTTP.post(`/orders/${orderId}/documentPayment`, payment)).data;
const deleteDocumentPayment = (orderId, paymentId) => HTTP.delete(`/orders/${orderId}/documentPayment/${paymentId}`);
const processEcheck = async (data) => (await HTTP.post('/orders/echeck/processpayment', data)).data;
const createPOInvoice = async (orderId, poId, invoice) =>
  (await HTTP.post(`/orders/${orderId}/purchaseOrders/${poId}/invoices`, invoice)).data;
const updatePOInvoice = async (orderId, poId, invoice) =>
  (await HTTP.put(`/orders/${orderId}/purchaseOrders/${poId}/invoices/${invoice._id}`, invoice)).data;
const deletePOInvoice = async (orderId, poId, invoiceId) =>
  (await HTTP.delete(`/orders/${orderId}/purchaseOrders/${poId}/invoices/${invoiceId}`)).data;
const sendOrderTrackingEmail = async (orderId, poId, body) =>
  (await HTTP.post(`/orders/${orderId}/purchaseOrders/${poId}/tracking-email`, body)).data;
const deleteOrderArtwork = ({ artworkId, orderId }) => HTTP.delete(`/orders/${orderId}/artwork/${artworkId}`);
const checkTrackingNumberExists = async (orderId, trackingData) =>
  (await HTTP.post(`/orders/${orderId}/check-exists-tracking`, trackingData)).data;
const sendOrderEmail = async (body, type) => (await HTTP.post(`/orders/${body.orderId}/send/${type}`, body)).data;
const sendOrdersEmail = async (body, type) =>
  (await HTTP.post(`/orders/${body.orderIds[0]}/send/batch/${type}`, body)).data;

const addOrderCharge = async (data) => (await HTTP.post(`/orders/${data.orderId}/additional-charge`, data)).data;
const updateOrderCharge = async (data) =>
  (await HTTP.put(`/orders/${data.orderId}/additional-charge/${data._id}`, data)).data;
const deleteOrderCharge = async (orderId, chargeId) =>
  (await HTTP.delete(`/orders/${orderId}/additional-charge/${chargeId}`)).data;

export {
  getOrderCustomer,
  getOrderFollowUps,
  createOrder,
  patchOrder,
  createOrderFollowUp,
  getOrderFollowUp,
  createOrderFollowUpNote,
  updateOrderFollowUp,
  searchFollowUps,
  getFollowUpTypeCount,
  getFollowUpTypePastCount,
  getLastViewedOrders,
  sendPurchaseInvoice,
  getOneOrderDetail,
  uploadOrderDocuments,
  deleteOrderDocuments,
  updateOrderDocument,
  getOrderFollowUpTypes,
  getOrderPayments,
  createDocumentPayment,
  deleteDocumentPayment,
  processEcheck,
  createPOInvoice,
  updatePOInvoice,
  deletePOInvoice,
  updateOrder,
  saveOrderDocument,
  sendOrderTrackingEmail,
  sendOrderEmail,
  sendOrdersEmail,
  deleteOrderArtwork,
  checkTrackingNumberExists,
  addOrderCharge,
  updateOrderCharge,
  deleteOrderCharge
};
